<script setup lang="ts">
/* Shown while the session is being restored, before any route renders. */
import Logo from '@/components/Logo.vue'

withDefaults(defineProps<{ label?: string }>(), { label: 'Loading' })
</script>

<template>
  <div class="wrap" role="status" aria-live="polite">
    <Logo mark-only :size="40" class="logo" />
    <span class="sr-only">{{ label }}</span>
  </div>
</template>

<style scoped>
.wrap {
  display: grid;
  place-items: center;
  min-height: 100dvh;
  background-color: var(--color-bg);
}

.logo {
  animation: pulse 1.4s var(--ease) infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.35;
    transform: scale(0.96);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
